module.exports = __webpack_public_path__ + "static/media/VIPESSRG.db313ad4.TTF";